import {GraphLevel} from '@domain/rcfa'
import {ApiClient} from '@hconnect/apiclient'
import {AttachmentFile} from '@hconnect/common/types'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useParams} from 'react-router'

export type ResponseType = {
  analysisId: number
  levels: GraphLevel[]
  selectedNodeId: number
}

export const QueryKey = 'graph-data'

export type NodeUpdateData = {
  id: number
  order?: number
  parent?: number
  title: string
  description?: string
  causeProbability?: string
  newAttachments?: Array<AttachmentFile>
}

export const useUpdateNode = (id?: string) => {
  const params = useParams()
  const urlId = params.analysisId
  const analysisId = id ? id : urlId
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (nodeData: NodeUpdateData) => {
      const path = `/rootcausefailureanalysis/analyses/${analysisId}/tree/nodes`
      const formData = new FormData()
      formData.append('Id', nodeData.id.toString())
      if (nodeData.causeProbability) formData.append('CauseProbability', nodeData.causeProbability)
      if (nodeData.title) formData.append('Title', nodeData.title)
      if (nodeData.description) formData.append('Description', nodeData.description)
      if (nodeData.parent) formData.append('Parent', nodeData.parent.toString())
      if (nodeData.order !== undefined) formData.append('Order', nodeData.order.toString())
      if (nodeData.newAttachments)
        // @ts-expect-error wrong mapping
        nodeData.newAttachments.map((file) => formData.append('NewAttachments', file))
      return (
        await ApiClient.axiosInstance.put<ResponseType>(path, formData, {
          headers: {
            'content-type': 'multipart/form-data'
          }
        })
      ).data
    },
    onSuccess: async (data: ResponseType) => {
      await queryClient.invalidateQueries({queryKey: ['node-detail']})
      await queryClient.invalidateQueries({queryKey: ['analysis-detail']})
      await queryClient.invalidateQueries({queryKey: ['graph-data']})
      queryClient.removeQueries({queryKey: ['analysis-list']})
      queryClient.removeQueries({queryKey: ['tasks-master-list']})
      queryClient.removeQueries({queryKey: ['analysis-pdfsummary']})
      queryClient.removeQueries({queryKey: ['analysis-summary']})
      return data
    }
  })
}
